import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import getServiceProperty from '../../../../helpers/getServiceProperty';
import { getServicePrice } from '../../../../selectors';
import { orderCompleted } from '../../../../actions/tracking';
import styles from './PaymentConfirmation.scss';
import { withBreakpoint } from '../../../../enhancers';
import Heading from '../../../Heading';
import { subscriptionTypes } from 'rp-auth';

const { TIPPING, INSIGHTS } = subscriptionTypes;

const subscriptions = {
  insights: INSIGHTS.toLowerCase(),
  tipping: TIPPING.toLowerCase(),
};

class PaymentConfirmation extends PureComponent {
    static propTypes = {
      modal: PropTypes.bool.isRequired,
    };

    componentDidMount() {
      if (this.props.confirmation) {
        this.props.orderCompleted(true);
      } else {
        this.props.orderCompleted(false);
      }
    }

    getAuthUrl = (data) => {
      const title = data.title.toLowerCase();

      if (title.includes(subscriptions.insights)) {
        return 'https://www.racingpost.com/subscriptions/insights/';
      } else if (title.includes(subscriptions.tipping)) {
        return 'https://www.racingpost.com/subscriptions/tipping/';
      }
      return 'https://www.racingpost.com/subscriptions/welcome-to-your-subscription/';
    };

    convertPeriodNumToText = (period) => {
      const textPeriod = [
        'one',
        'two',
        'three',
        'four',
        'five',
        'six',
        'eight',
        'nine',
        'ten',
        'eleven',
        'twelve',
      ];

      return textPeriod[period - 1];
    };

    render() {
      const {
        modal,
        subscription: { data },
      } = this.props;

      const logoutUrl = `${window.location.origin}/api/auth/logout`;

      return (
        <div className={classNames(styles.root, { [styles.modal]: modal })}>
          {!modal && <Heading breakpoint={this.props.breakpoint} showDescription={false} />}
          <div className={classNames(styles.main, { [styles.modal]: modal })}>
            <div className={styles.boldLabel}>Congratulations</div>
            <section className={styles.centeredText}>
              <div className={styles.headingSmall}>Complete!</div>
              <div className={styles.headingBig}>{`Welcome to ${data.title}`}</div>
            </section>
            <div className={styles.content}>
              <img src="/svgs/padlock_unlocked.svg" className={styles.icon} alt="padlock" />
            </div>
            <div className={styles.content}>
              <span className={styles.headingSmall}>
                            Get started with your subscription and enjoy access to all of your new
                            content
              </span>
            </div>
            <div className={styles.separator}>
              <a href={this.getAuthUrl(data)} className={styles.loginBtnLink}>
                <span>Get Started</span>
              </a>
            </div>
            <div className={styles.action}>
              <a href={logoutUrl} className={classNames(styles.button, styles.backBtn)}>
                <span>Back home</span>
              </a>
            </div>
          </div>
        </div>
      );
    }
}

function mapStateToProps(state) {
  const subscriptionData = state.subscriptions.selected.id
    ? state.subscriptions.selected
    : state.subscriptions.options.find(option =>
      option.id ===
                  state.subscriptions.selectedOption.defaultSubscriptionInfo.subscriptionId);

  const type = getServiceProperty(subscriptionData.id, 'type').toLowerCase();
  const priceTag =
        (state.confirmation && state.confirmation.amount) ||
        getServicePrice(state, subscriptionData.id);
  const headerPriceTag = getServicePrice(state);

  const confirmVoucherData = state.confirmation.voucherData;

  const voucherData = confirmVoucherData ? JSON.parse(state.confirmation.voucherData) : null;
  const isVoucherApplied = !!voucherData;

  const price = voucherData ? Number(voucherData.DisplayPrice.slice(1)) : priceTag;
  const headerPrice = voucherData ? voucherData.OriginalPrice.slice(1) : headerPriceTag;
  const voucherPeriodNum = voucherData ? voucherData.VoucherPeriodNum : null;

  return {
    subscription: {
      data: subscriptionData,
      meta: {
        type,
        price,
        headerPrice,
        voucherPeriodNum,
        isVoucherApplied,
      },
    },
  };
}

export default compose(
  withBreakpoint,
  connect(
    mapStateToProps,
    { orderCompleted },
  ),
)(PaymentConfirmation);
